const readText = (value: unknown): string => String(value ?? '').trim();

const DOMAIN_LABEL_PATTERN = /^[\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?$/u;
// Conservative unquoted dot-atom: quoted local parts and exotic specials are
// intentionally rejected for the parent financial aid form.
const LOCAL_PART_PATTERN = /^[\p{L}\p{N}](?:[\p{L}\p{N}._%+'-]*[\p{L}\p{N}])?$/u;

export const isValidFinancialAidParentEmail = (value: unknown): boolean => {
  const normalized = readText(value).normalize('NFC').toLowerCase();
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(normalized)) return false;
  if (normalized.includes('..')) return false;

  const [localPart = '', domain = ''] = normalized.split('@');
  if (!localPart || !domain) return false;
  if (localPart.startsWith('.') || localPart.endsWith('.')) return false;
  if (!LOCAL_PART_PATTERN.test(localPart)) return false;

  const domainLabels = domain.split('.');
  if (domainLabels.length < 2) return false;
  if (!domainLabels.every((label) => DOMAIN_LABEL_PATTERN.test(label))) return false;

  // IP-style hosts (bracketed or bare) are rejected: the last label must be a
  // named TLD containing at least one letter.
  const topLevelLabel = domainLabels[domainLabels.length - 1] ?? '';
  return /\p{L}/u.test(topLevelLabel);
};
